import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute, Router, ActivatedRouteSnapshot, NavigationEnd, Event as NavigationEvent } from '@angular/router';
import { RootScopeService } from '../../core/shared-service/root-scope.service';
import { RootScopeDeclare } from '../../core/rootscope-declare';
import { Subscription } from 'rxjs';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { SelectionInfo } from '../selectors/multi-selection/multi-selection.model';
import { CommonUtil } from 'src/app/core/Utils/common-util';
import { RemoteUpdateComponent } from './remote-update/remote-update.component';
import { LifescapeCoursesComponent } from './lifescape-courses/lifescape-courses.component';

@Component({
  selector: 'app-software',
  templateUrl: './software.component.html',
  styleUrls: ['./software.component.scss']
})
export class SoftwareComponent implements OnInit {
  private _tabOnChange: Subscription;
  private selectionInfo: SelectionInfo;
  private activeComponentTab: any;

  private rootScopeData: RootScopeDeclare;
  private currentTab = 'remoteupdate';

  // for mobile tooltip
  @ViewChild('stt1', { static: false }) mytooltip1: NgbTooltip;

  tabData = [
    { id: 'remoteupdate', jsonKey: 'REMOTE.UPDATES', consoleProp: 'hasRemoteUpdate' },
    { id: 'lifescapeupdate', jsonKey: 'INTERACTIVE.TERRAINS', consoleProp: 'hasLifescapeCourseUpdate' },
    { id: 'softwareDownload', jsonKey: 'DOWNLOAD.SOFTWARE', consoleProp: '' }
  ];
  currentTabObj = [{ id: 'remoteupdate', jsonKey: 'REMOTE.UPDATES', consoleProp: 'hasRemoteUpdate' }];

  constructor(private rootScopeService: RootScopeService,
    private _route: ActivatedRoute,
    private _router: Router,
    private commonUtil: CommonUtil
  ) {
  }

  getRootScopeData(): void {
    this.rootScopeService.getRootScope().subscribe(rootScopeData => {
      this.rootScopeData = rootScopeData;
    });
  }

  setPageName(name: string): void {
    this.rootScopeData.pageName = name;
  }

  ngOnInit(): void {
    this.getRootScopeData();
    this.currentTab = ((this._route.snapshot.firstChild as ActivatedRouteSnapshot).url).toString();
    this.currentTabObj = this.tabData.filter(currentTabObj => currentTabObj.id === this.currentTab);
    this.setPageName('Software - ' + this.currentTabObj[0].id);
    this._tabOnChange = this._router.events.subscribe(
      (event: NavigationEvent): void => {
        if (event instanceof NavigationEnd) {
          this.currentTab = ((this._route.snapshot.firstChild as ActivatedRouteSnapshot).url).toString();
          this.currentTabObj = this.tabData.filter(currentTabObj => currentTabObj.id === this.currentTab);
          this.setPageName('Software - ' + this.currentTabObj[0].id);
          // this._router.routeReuseStrategy.shouldReuseRoute = function () {
          //   return false;
          // };
        }
      }
    );
  }

  ngOnDestroy() {
    this._tabOnChange.unsubscribe();
  }

  stopPropagation(e: Event) {
    e.stopPropagation();
    if (this.mytooltip1.isOpen()) {
      this.mytooltip1.close();
    } else {
      this.mytooltip1.open();
    }
  }

  private onSelectionChange(selectionInfo: SelectionInfo) {
    setTimeout(() => {
      this.selectionInfo = selectionInfo;
      if(selectionInfo.facility.summary?.facilityRights.software === 'true') {
        this.activeComponentTab?.onSelectionChange(this.selectionInfo);
      } else{
        this.commonUtil.redirectToAvailablePage();
      } 
    });
  }

  private onTabActivated(componentRef: any) {
    if(componentRef instanceof RemoteUpdateComponent || 
      componentRef instanceof LifescapeCoursesComponent) {
      this.activeComponentTab = componentRef;
      componentRef.onSelectionChange(this.selectionInfo);
    }
  }

}
